export default "__VITE_ASSET__DYFocY09__"